import Loadable from 'react-loadable'
import Loading from '../../components/Loading/Loading'

const OpinionContainer = Loadable({
  loader: () => import('./containers/OpinionContainer'),
  loading: Loading,
})

export default {
  path: '/reports/:id',
  component: OpinionContainer
}



// WEBPACK FOOTER //
// ./src/routes/opinion/index.js